import styled from 'styled-components';
import { color, fontSize } from 'theme';

export const PermissionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  height: 100%;
`;

export const PermissionTitle = styled.h2`
  color: ${color.lightGrey};
  font-size: ${fontSize.large};
  margin-bottom: 20px;
  font-weight: 600;
`;

export const PermissionText = styled.p`
  color: ${color.lightGrey};
  font-size: ${fontSize.medium};
  margin-bottom: 30px;
  line-height: 1.5;
  max-width: 400px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
`;
